import React, { Component } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './CarouselBanner.css';

class CarouselBanner extends Component {
  render() {
    const { bannerList = [] } = this.props;

    return (
      <Carousel
        className="carousel-banner-wrapper"
        controls={false}
        key={bannerList.length} // Workaround for Carousel stuck index bug
      >
        {bannerList.map(({ title, Element }) => (
          <Carousel.Item key={`key-${title}`}>
            <Element />
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }
}

export default CarouselBanner;
